var _style, _path, _path2, _path3, _path4, _path5, _text, _text2, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _text3, _text4, _path11, _path12, _path13, _text5, _path14, _path15, _text6, _path16, _text7, _path17, _text8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItem5Chtr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 750 289"
    },
    viewBox: "0 0 750 289",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .st1{fill:#fff}.st2{fill:#666}.st3{fill:#7f7f7f}.st4{fill:#000}.st5{font-size:14.3971px}.st6{fill:#369;fill-opacity:.502}.st7{font-family:&apos;ArialUnicodeMS&apos;}.st8{font-size:11.4815px}\n  ")), /*#__PURE__*/React.createElement("path", {
    d: "M750 0H0v289.4h750V0z",
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M255.3 153.4v-40.7h-77.1v40.7h77.1z",
    className: "st1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M256 154.2v-42h-78.4v42H256m-1.3-40.7v39.3h-75.8v-39.3h75.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M256 194.3v-40.4h-77.1v40.4H256z",
    className: "st2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M256 194.3v-41.7h-78.4v41.7H256m-1.3-40.4V193h-75.8v-39.1h75.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M232.3 85.3v-4.1h-31.1v4.1h2.5V95c0 1.5-.8 3.1-2.6 4.7-3 2.6-6.7 4.8-11.1 6.6-4.5 1.8-8.2 2.7-10.9 2.8h-.3l-.1.1c-1.8.5-2.8 1.7-3 3.6V196h81.8v-83.2c-.2-1.9-1.2-3.1-3-3.6l-.1-.1h-.3c-1.8 0-4-.5-6.7-1.3-4.3-1.4-8.3-3.2-12.1-5.7-1.8-1.1-3.2-2.3-4.2-3.6-1.1-1.3-1.6-2.5-1.6-3.6v-9.7l2.8.1m-1.3-2.7V84h-2.5v11.1c0 2 1.1 3.9 3.2 5.7 3 2.8 6.8 5.1 11.4 6.8 4.3 1.7 8 2.7 11.1 2.9h.1c1.3.3 2 1.1 2.1 2.4v81.8h-79.2v-81.8c.1-1.3.8-2.1 2.1-2.4h.3c1.8-.1 4.1-.6 6.7-1.4 4.4-1.3 8.5-3.2 12.4-5.7 1.8-1.3 3.4-2.6 4.6-3.9 1.2-1.4 1.8-2.9 1.8-4.3V84h-2.5v-1.4H231z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "st4 st5 st7",
    transform: "matrix(.9981 0 0 1 210.1172 138.3682)"
  }, "\n    \u6C34\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "st4 st5 st7",
    transform: "matrix(.9981 0 0 1 210.1172 178.3682)"
  }, "\n    \u6CB9\n  ")), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M226.6 88.5l1.6-3.9h-22.8l1.1 3.9h20.1z",
    className: "st3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M413.9 153.5v-40.7h-77.2v40.7h77.2z",
    className: "st2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M414.6 154.2v-42H336v42h78.6m-1.4-40.7v39.3h-75.9v-39.3h75.9z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M413.9 193.6v-40.4h-77.2v40.4h77.2z",
    className: "st1"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M414.6 194.3v-41.7H336v41.7h78.6m-1.4-40.4V193h-75.9v-39.1h75.9z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M388.2 85.3h2.5v-4.1h-31.1v4.1h2.6V95c-.1 1.5-1 3.1-2.8 4.7-2.9 2.6-6.6 4.8-11.1 6.6-4.5 1.8-8.1 2.7-10.8 2.8h-.4l-.1.1c-1.8.5-2.7 1.7-2.8 3.6V196h81.7v-83.2c-.1-1.9-1.1-3.1-2.9-3.6l-.1-.1h-.3c-1.7 0-3.9-.5-6.7-1.3-4.2-1.4-8.2-3.2-12.1-5.7-1.8-1.1-3.2-2.3-4.2-3.6-1.1-1.3-1.6-2.5-1.6-3.6v-9.6m1.4-2.7V84h-2.5v11.1c.1 2 1.2 3.9 3.2 5.7 3.1 2.8 6.9 5.1 11.4 6.8 4.4 1.7 8.1 2.7 11.1 2.9h.3c1.2.3 1.8 1.1 2 2.4v81.8h-79.1v-81.8c0-1.3.7-2.1 2-2.4h.3c1.9-.1 4.2-.6 6.8-1.4 4.3-1.3 8.5-3.2 12.4-5.7 1.8-1.3 3.4-2.6 4.6-3.9 1.1-1.4 1.8-2.9 1.8-4.3V84H361v-1.4h28.4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M385.1 88.5l1.7-3.9h-22.9l1.1 3.9h20.1z",
    className: "st3"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "st4 st5 st7",
    transform: "matrix(.9981 0 0 1 368.1172 138.3682)"
  }, "\n    \u6CB9\n  ")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "st4 st5 st7",
    transform: "matrix(.9981 0 0 1 368.1172 178.3682)"
  }, "\n    \u6C34\n  ")), /*#__PURE__*/React.createElement("path", {
    d: "M572.3 112.8h-77.1v81h77.1v-81z",
    style: {
      fill: "#999"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M494.5 194.6H573v-82.4h-78.4v82.4m1.3-1.4v-79.7h75.8v79.7h-75.8z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M546.6 85.3h2.6v-4.1h-31.1v4.1h2.5V95c0 1.5-.9 3.1-2.8 4.7-2.9 2.6-6.6 4.8-11.1 6.6-4.4 1.8-8 2.7-10.8 2.8h-.3l-.1.1c-1.8.5-2.8 1.7-2.9 3.6V196h81.7v-83.2c-.1-1.9-1.1-3.1-2.8-3.6l-.1-.1h-.3c-1.8 0-4-.5-6.8-1.3-4.3-1.4-8.2-3.2-12-5.7-1.8-1.1-3.3-2.3-4.3-3.6-1.1-1.3-1.6-2.5-1.6-3.6v-9.6m1.5-2.7V84h-2.6v11.1c.1 2 1.2 3.9 3.2 5.7 3.2 2.8 7 5.1 11.4 6.8 4.3 1.7 8 2.6 11.1 2.8v.1h.3c1.3.3 1.9 1.1 2 2.4v81.8h-79.1v-81.8c.1-1.3.8-2.1 2-2.4h.3c1.9-.1 4.2-.6 6.8-1.4 4.3-1.3 8.4-3.2 12.4-5.7 1.9-1.3 3.4-2.6 4.6-3.9 1.2-1.4 1.8-2.9 1.8-4.3V84h-2.5v-1.4h28.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M543.5 88.5l1.7-3.9h-22.9l1.2 3.9h20z",
    className: "st3"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "st4 st5 st7",
    transform: "matrix(.9981 0 0 1 510.1172 155.3682)"
  }, "\n    \u6C34\u8207\u6CB9\n  ")), /*#__PURE__*/React.createElement("path", {
    d: "M587.8 207.6v-12.4H162.1v12.4h425.7z",
    style: {
      fill: "#bfbfbf"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M588.5 208.3v-13.7h-427v13.7h427m-1.3-12.3v11H162.8v-11h424.4z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M225.2 215.8c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6-2.4 2.4-3.6 5.3-3.6 8.7s1.2 6.3 3.6 8.7c2.4 2.4 5.3 3.6 8.7 3.6s6.2-1.2 8.6-3.6c2.4-2.4 3.6-5.3 3.6-8.7s-1.2-6.3-3.6-8.7z",
    className: "st6"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "st1 st7 st8",
    transform: "matrix(.9981 0 0 1 212.667 229.3682)"
  }, "\n    1\n  ")), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M383.7 215.8c-2.4-2.4-5.2-3.6-8.6-3.6s-6.3 1.2-8.7 3.6c-2.4 2.4-3.6 5.3-3.6 8.7s1.2 6.3 3.6 8.7 5.3 3.6 8.7 3.6c3.4 0 6.2-1.2 8.6-3.6 2.4-2.4 3.6-5.3 3.6-8.7 0-3.4-1.2-6.3-3.6-8.7z",
    className: "st6"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    className: "st1 st7 st8",
    transform: "matrix(.9981 0 0 1 371.2168 229.3682)"
  }, "\n    2\n  ")), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M544.6 215.8c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6-2.4 2.4-3.6 5.3-3.6 8.7s1.2 6.3 3.6 8.7c2.4 2.4 5.3 3.6 8.7 3.6s6.2-1.2 8.6-3.6c2.4-2.4 3.6-5.3 3.6-8.7 0-3.4-1.2-6.3-3.6-8.7z",
    className: "st6"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    className: "st1 st7 st8",
    transform: "matrix(.9981 0 0 1 532.1172 229.3682)"
  }, "\n    3\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem5Chtr);
export default __webpack_public_path__ + "static/media/item5chtr.d5116bf26d6aaf3e303400e273155768.svg";
export { ForwardRef as ReactComponent };